module.exports = __webpack_public_path__ + "static/img/servicesBanner1.d4a79687.png";